export default {
    name: " Enquiry & Sales Execution",
    meta: {
        icon: "note_add",
        expanded: true,
        auth: true
    },

    departmentName: "Enquiry & Pricing",
    finalPagePermision: "",

    children: [
        {
            name: "Sales Execution Details",
            keywords: ['Sales Execution Details', 'Enquiry'],
            permissionName: 'Enquiry',
            path: "/viewAllModuleDetails/viewAllModuleDetails",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/allModuleForm/viewAllModuleDetails.vue"),
            finalPagePermision: "",

        },

    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/salesExecution.js